import React from 'react';

import NavBar from './NavBar';

import screen_mockups from "../assets/img/screen-mockups.svg";
import icon_communities from "../assets/img/icon-communities.svg";
import icon_messages from "../assets/img/icon-messages.svg";

const Header = () => {
  return (
    <header className="hero">

        <NavBar />

        <section className="hero__main">

          <div className="hero__text">
            <h1 className="hero__title">Build The Community Your Fans Will Love</h1>
            <p className="hero__paragraph">
                Huddle re-imagines the way we build communities. You have a voice, but so does 
                your audience. Create connections with your users as you engage in genuine discussion.
            </p>
            <a href="www.google.com" className="cta">
              Get Started For Free
            </a>
          </div>

          <figure className="hero__picture scale-up-center">
            <img src={screen_mockups} alt="" className="hero__img" />
          </figure>

          <div className="hero__numbers">
            <div className="hero__item">
              <img src={icon_communities} alt="" className="hero__icon" />
              <h3 className="hero__number">1.4k+</h3>
              <p className="hero__community">Communities Formed</p>
            </div>
            <div className="hero__item">
              <img src={icon_messages} alt="" className="hero__icon" />
              <h3 className="hero__number">2.7m</h3>
              <p className="hero__community">Messages Sent</p>
            </div>
          </div>

        </section>
        
        <div className="wave wave--bottom"></div>
    </header>
  )
}

export default Header